import { Injectable } from '@angular/core';
import { PaymentMode } from '@core/models/payment-mode.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable()
export class PaymentModeEntityService extends EntityCollectionServiceBase<PaymentMode> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('PaymentMode', serviceElementsFactory);
    }
}
